import { Form, Formik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AuthFormTitle from "../../components/GeneralComponents/AuthFormTitle";
import Button from "../../components/GeneralComponents/Button";
import FormObserver from "../../components/GeneralComponents/FormObserver";
import GeneralInput from "../../components/GeneralComponents/GeneralInput";
import { useAuthContext } from "../../context/AuthContext";
import history from "../../hooks/History";
import { setCreatePasswordType } from "../../redux/slices/authSlice";
import {
  allowedFilesExtensions,
  ArabicCode,
  DefaultNavigateDelay,
  EnglishCode,
} from "../../utils/constants/CommonConstants";
import useCongratsSchema from "../../utils/validations/auth/congratsSchema";
import CustomUploadFileInput from "../../components/GeneralComponents/CustomUploadFileInput";
import { RootState } from "../../redux/store";
import { setStaffDocument } from "../../redux/slices/commonSlice";

const CongratsPage: React.FC = () => {
  const { t, i18n } = useTranslation("translation");
  const { changeShowLeaveAuthRoutePopupAuthState } = useAuthContext();
  const dispatch = useDispatch();
  const congratsSchema = useCongratsSchema();
  const [initialValues, setInitialValues] = useState<any>({
    full_name: "",
  });
  const { user } = useSelector((state: RootState) => state.auth);
  const isPharmacy = user?.currentFacility?.FacilityType.Code === "pharmacy";
  //?===================== Handle form submission====================
  const handleSubmit = (values: any) => {
    if (values.full_name) {
      changeShowLeaveAuthRoutePopupAuthState(false);
      dispatch(setCreatePasswordType("NewStaff"));
      localStorage.setItem("full_name_congrats_page", values.full_name);
      dispatch(setStaffDocument(values.staffDocument));
      setTimeout(() => {
        history.push("/auth/create-password");
      }, DefaultNavigateDelay);
    }
  };
  return (
    <article className="z-20 flex w-full flex-col gap-6 px-8 py-10 xl:w-[75%]">
      <div className="flex flex-col gap-6">
        <AuthFormTitle title="DomeCare" desc="Warehouse & Pharmacy" />
        <div className="flex flex-col gap-2">
          <p className="text-center text-2xl font-bold text-headingTextColor">
            {t("Congratulations")} 🎉
          </p>
          <p className="text-center text-base font-normal text-textColor">
            {t("Congratulations_desc")}
          </p>
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={congratsSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form className="flex flex-col gap-5">
            <GeneralInput
              name="full_name"
              type="text"
              arabicOnly={i18n.language === ArabicCode ? true : false}
              englishOnly={i18n.language === EnglishCode ? true : false}
              placeholder={t("full_name")}
              required={true}
            />
            {isPharmacy && (
              <CustomUploadFileInput
                setFieldValue={setFieldValue}
                FieldName={"staffDocument"}
                allowedFormats={allowedFilesExtensions}
                placeholder={""}
                allowedFormatsPlaceholder={t("facility_license_extensions")}
              />
            )}
            <Button
              title={t("complete")}
              type="submit"
              variant="primary"
              extraClassName="shadow-cta"
            />
            <FormObserver setInitialValues={setInitialValues} values={values} />
          </Form>
        )}
      </Formik>
    </article>
  );
};

export default CongratsPage;
